import { render, staticRenderFns } from "./FacPollingAndSockets.vue?vue&type=template&id=3c08785b&scoped=true&"
import script from "./FacPollingAndSockets.vue?vue&type=script&lang=js&"
export * from "./FacPollingAndSockets.vue?vue&type=script&lang=js&"
import style0 from "./FacPollingAndSockets.vue?vue&type=style&index=0&id=3c08785b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c08785b",
  null
  
)

export default component.exports